// HTML collapses literal tab characters; approximate Word's 0.5" default tab stop
// with a run of non-breaking spaces.
export const TAB_AS_NBSP = '    ';
